/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _style3 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style4 = require('antd/lib/date-picker/style');

var _datePicker = require('antd/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

require('./index.less');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MonthPicker = _datePicker2.default.MonthPicker,
    RangePicker = _datePicker2.default.RangePicker;

var Mixtime = function (_Component) {
  (0, _inherits3.default)(Mixtime, _Component);

  function Mixtime(props, connect) {
    (0, _classCallCheck3.default)(this, Mixtime);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Mixtime.__proto__ || (0, _getPrototypeOf2.default)(Mixtime)).call(this, props, connect));

    _this.state = {
      timeStatus: 1,
      agoDate: "",
      nowDate: ""
    };
    return _this;
  }

  (0, _createClass3.default)(Mixtime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.tabSelect(1);
    }
  }, {
    key: 'timeChange',
    value: function timeChange(date, dateString) {
      if (dateString[0]) {
        var start = Date.parse(new Date(dateString[0]));
        var end = Date.parse(new Date(dateString[1]));
        var cha = (end - start) / 1000 / 3600 / 24;
        if (cha > 7) {
          _message2.default.error("日期相差不可超过7天", 5);
        } else {
          this.props.callBack(dateString);
          this.setState({
            agoDate: dateString[0],
            nowDate: dateString[1]
          });
        }
      }
    }
  }, {
    key: 'tabSelect',
    value: function tabSelect(arg) {
      var now = new Date();
      var timestamp = Date.parse(now);
      var nowDay = now.getDate();
      var nowMonth = now.getMonth() + 1;
      var nowYear = now.getFullYear();
      var nowDate = nowYear + '/' + nowMonth + '/' + nowDay;
      var agoDate, agoDay, agoMonth, agoYear, daysCha;
      agoDate = nowYear + '/' + nowMonth + '/' + 1;
      if (arg == 1) {
        var nowDayOfWeek = now.getDay();
        if (nowDayOfWeek === 0) {
          daysCha = 7;
        } else {
          daysCha = nowDayOfWeek - 1;
        }
        var stampcha = daysCha * 1000 * 60 * 60 * 24;
        var trannow = new Date(timestamp - stampcha);
        agoDay = trannow.getDate();
        agoMonth = trannow.getMonth() + 1;
        agoYear = trannow.getFullYear();
        agoDate = agoYear + '/' + agoMonth + '/' + agoDay;
      }
      this.props.callBack([agoDate, nowDate]);
      this.setState({
        timeStatus: arg,
        agoDate: agoDate,
        nowDate: nowDate
      });
    }
  }, {
    key: 'render',
    value: function render() {
      // function disabledDate(current) {
      //   var now = new Date();
      //   var stampcha = 1 * 1000 * 60 * 60 *24;
      //   var timestamp = Date.parse(now)-stampcha;
      //   var timestamp7 = Date.parse(now) - stampcha*7;
      //   if(current.valueOf() < timestamp7||current.valueOf()>Date.now()){
      //     return true;
      //   }else{
      //     return false;
      //   }
      // }
      var dateFormat = 'YYYY/MM/DD';
      var _state = this.state,
          timeStatus = _state.timeStatus,
          agoDate = _state.agoDate,
          nowDate = _state.nowDate;

      return (0, _jsx3.default)('div', {
        className: 'cp-mixtime'
      }, void 0, (0, _jsx3.default)(RangePicker, {
        value: [(0, _moment2.default)(agoDate, dateFormat), (0, _moment2.default)(nowDate, dateFormat)],
        format: dateFormat,
        onChange: this.timeChange.bind(this)
      }), (0, _jsx3.default)('div', {
        className: 'tabs'
      }, void 0, (0, _jsx3.default)('div', {
        className: timeStatus == 1 ? "active-tab" : null,
        onClick: this.tabSelect.bind(this, 1)
      }, void 0, '\u672C\u5468')));
    }
  }]);
  return Mixtime;
}(_react.Component);

exports.default = Mixtime;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/components/mixtime/index.jsx
// module id = 435
// module chunks = 0